<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-loadingbox">
            <div class="mcf-loadingbox-form">
                <i class="fa fa-spinner fa-spin"></i>
                <label>Veuillez patienter</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
    },
    data(){
        return {
            
        };
    },
    created() {
        
    },
    methods:{
        
    }
}
</script>